export default {
    tags: [],
    serviceOptions: [],
    facilityOptions: [],
    parkingOptions: [],
    goodForOptions: [],
    mealOptions: [],
    foodOptions: [],
    tagsObject: {},
    serviceOptionsObject: {},
    facilityOptionsObject: {},
    parkingOptionsObject: {},
    goodForOptionsObject: {},
    mealOptionsObject: {},
    foodOptionsObject: {},
};
